import type { ChartType } from '../PageConfigProvider/types/chart';
import type { DataSourceType } from '../PageConfigProvider/types/item';

export type ChartBuilderPanelVisibility = {
  showChartOptionBlock: boolean;
  snowflakeTableReportLayout: boolean;
  metricSelectorKind: 'none' | 'single' | 'multi';
  showSecondaryDimensionSelector: boolean;
  showDimensionSourceSelector: boolean;
  showDataFilterSelector: boolean;
  showReportParameterSelector: boolean;
};

export const getChartBuilderPanelVisibility = ({
  chartType,
  hasPrimaryFilter,
  isReport,
  customReportsSnowflakeEnabled,
  dataSource,
}: {
  chartType?: ChartType;
  hasPrimaryFilter: boolean;
  isReport: boolean;
  customReportsSnowflakeEnabled: boolean;
  dataSource?: DataSourceType;
}): ChartBuilderPanelVisibility => {
  const showChartOptionBlock = Boolean(
    chartType && chartType !== 'text' && chartType !== 'image'
  );

  const snowflakeTableReportLayout =
    showChartOptionBlock &&
    chartType === 'table' &&
    isReport &&
    customReportsSnowflakeEnabled &&
    dataSource === 'snowflake';

  const metricSelectorKind = (() => {
    if (!showChartOptionBlock) return 'none';
    if (snowflakeTableReportLayout) return 'single';
    if (chartType === 'table') return 'multi';
    return 'single';
  })();

  const showSecondaryDimensionSelector =
    showChartOptionBlock && !snowflakeTableReportLayout && hasPrimaryFilter;

  const showDimensionSourceSelector =
    showChartOptionBlock && !snowflakeTableReportLayout && hasPrimaryFilter;

  const showDataFilterSelector =
    showChartOptionBlock && !snowflakeTableReportLayout;

  const showReportParameterSelector =
    showChartOptionBlock &&
    !snowflakeTableReportLayout &&
    hasPrimaryFilter &&
    isReport;

  return {
    showChartOptionBlock,
    snowflakeTableReportLayout,
    metricSelectorKind,
    showSecondaryDimensionSelector,
    showDimensionSourceSelector,
    showDataFilterSelector,
    showReportParameterSelector,
  };
};
